// extracted by mini-css-extract-plugin
export default {"TruckSidebar_list":"YnKDiA94sTpnUs0zL4sf"};